export default __webpack_public_path__ + "static/media/billreynolds_pole_building.78bace9f.jpg";